import { render, staticRenderFns } from "./dataCell.vue?vue&type=template&id=72aa3b36&scoped=true&"
import script from "./dataCell.vue?vue&type=script&lang=js&"
export * from "./dataCell.vue?vue&type=script&lang=js&"
import style0 from "./dataCell.vue?vue&type=style&index=0&id=72aa3b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa3b36",
  null
  
)

export default component.exports